import updateDatalayer from "./gtm";

const accordionBtn = document.querySelectorAll('.accordion-collapse');

if (accordionBtn.length > 0) {
    Array.from(accordionBtn).forEach((element, index) => {
        element.addEventListener('shown.bs.collapse', function (event) {
            // Action to execute once the collapsible area is expanded
            const product_name = $(this).data('productName');
            const product_number = $(this).data('productNumber');
            const price = $(this).data('price');
            updateDatalayer('view_item', product_number, product_name, 1, price, null);
        });
    });
}
